import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { trackEvent } from '../utils/analytics'

export default function VideoSection() {
  const playerRef = useRef(null)
  const containerRef = useRef(null)
  const [isMuted, setIsMuted] = useState(true)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    // Load YouTube iframe API
    if (!window.YT) {
      const tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      document.head.appendChild(tag)
    }

    const initPlayer = () => {
      playerRef.current = new window.YT.Player(containerRef.current, {
        videoId: 'SCyrlyvUXQ0',
        playerVars: {
          autoplay: 1,
          mute: 1,
          rel: 0,
          modestbranding: 1,
          playsinline: 1,
          controls: 1,
          disablekb: 0,
          iv_load_policy: 3,
          fs: 1,
        },
        events: {
          onReady: () => setIsReady(true),
        },
      })
    }

    if (window.YT && window.YT.Player) {
      initPlayer()
    } else {
      window.onYouTubeIframeAPIReady = initPlayer
    }

    return () => {
      if (playerRef.current && playerRef.current.destroy) {
        playerRef.current.destroy()
      }
    }
  }, [])

  const handleUnmute = () => {
    if (playerRef.current) {
      playerRef.current.unMute()
      playerRef.current.setVolume(100)
      setIsMuted(false)
      trackEvent('video_unmute', { video: 'book_intro' })
    }
  }

  const handleMute = () => {
    if (playerRef.current) {
      playerRef.current.mute()
      setIsMuted(true)
    }
  }

  return (
    <section className="bg-white py-12">
      <div className="max-w-4xl mx-auto px-6">
        <div className="relative w-full rounded-lg overflow-hidden" style={{ paddingBottom: '56.25%', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
          <div ref={containerRef} className="absolute inset-0 w-full h-full" />

          {/* Unmute overlay — large, centered, impossible to miss */}
          {isReady && isMuted && (
            <div className="absolute inset-0 z-10 flex items-center justify-center">
              <button
                onClick={handleUnmute}
                className="bg-white text-gray-900 px-8 py-5 rounded-xl font-bold text-xl flex items-center gap-3 shadow-2xl hover:scale-105 transition-transform animate-bounce"
                style={{ animationDuration: '2s' }}
              >
                <span className="text-3xl">🔊</span>
                Click here to turn on sound
              </button>
            </div>
          )}

          {/* Mute button (shown when unmuted) */}
          {isReady && !isMuted && (
            <button
              onClick={handleMute}
              className="absolute bottom-14 left-1/2 -translate-x-1/2 z-10 bg-black/60 text-white px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2 hover:bg-black/80 transition-all"
            >
              🔇 Mute
            </button>
          )}
        </div>
        <div className="text-center mt-6">
          <p className="text-lg font-bold text-gray-700 mb-3">More videos on hidden history, racism, and accountability</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/videos"
              className="inline-block bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary-700 transition-colors"
            >
              ▶ Browse All Videos
            </Link>
            <a
              href="https://www.youtube.com/@angrysoccermom?sub_confirmation=1"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent('youtube_subscribe_click', { location: 'home_page' })}
              className="inline-block bg-red-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-red-700 transition-colors"
            >
              ▶ Subscribe on YouTube
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
